/*=========================================================================================
  File Name: moduleCountryMutations.js
  Description: Country Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  ADD_ITEM(state, item) {
    
    state.Properties.unshift(item)
  },
  SET_Properties(state, Properties) {
    
    try {
      // const parsedData = JSON.parse(OpportunityStatusList.data);
      state.Properties = Properties.Data;

    } catch (error) {
      console.error("Failed to parse properties data JSON:", error);
      state.Properties = [];
    }
  },
    GET_ITEM_BY_ID(state, Opportunity){
  
    try {
      //const parsedData = JSON.parse(Opportunity.data);
    
      state.Opportunity = Opportunity;
    } catch (error) {
      console.error("Failed to parse Opportunity data JSON:", error);
      state.Opportunity = {};
    }
  },

  SET_PropertyListingStatus(state, items) {
    
    try {
      // const parsedData = JSON.parse(OpportunityStatusList.data);
      state.PropertyListingStatus = items.Data;

    } catch (error) {
      console.error("Failed to parse properties data JSON:", error);
      state.PropertyListingStatus = [];
    }
  },
   UPDATE_Properties(state, Property) {

    const PropertyIndex = state.Properties.findIndex((p) => p.id == Property.ID)
    Object.assign(state.Properties[PropertyIndex], Property)
  },
  REMOVE_ITEM(state, itemId) {
    
      const ItemIndex = state.Properties.findIndex((p) => p.id == itemId)
      state.Properties.splice(ItemIndex, 1)
  },
  SET_PROPERTY_IMAGES(state, images) {
      state.propertyImages = images;
    },
    ADD_IMAGE_TO_LIST(state, image) {
      state.propertyImages.push(image);
    },

    UPDATE_IMAGE_IN_LIST(state, updatedImage) {
  const index = state.propertyImages.findIndex(i => i.Id === updatedImage.Id);
  if (index !== -1) {
    state.propertyImages.splice(index, 1, updatedImage);
  }
},
REMOVE_IMAGE_FROM_LIST(state, imageId) {
  state.propertyImages = state.propertyImages.filter(i => i.Id !== imageId);
},
// Document mutations
 SET_PROPERTY_DOCUMENTS(state, docs) {
    state.PropertyDocuments = docs;
  },
  ADD_PROPERTY_DOCUMENT(state, doc) {
    state.PropertyDocuments.push(doc);
  },
  UPDATE_PROPERTY_DOCUMENT(state, doc) {
    const index = state.PropertyDocuments.findIndex(d => d.Id === doc.Id);
    if (index !== -1) state.PropertyDocuments.splice(index, 1, doc);
  },
  REMOVE_PROPERTY_DOCUMENT(state, docId) {
    state.PropertyDocuments = state.PropertyDocuments.filter(d => d.Id !== docId);
  },

  SET_PROPERTY_RENTAL_DATA(state, data) {
    
    state.propertyRentalData = data;
  },
  UPDATE_RENTAL_DATA_LIST(state, updatedData) {
    state.propertyRentalData = updatedData;
  }
}
